import type { OriginalItemTypes, ToeicArtifactType } from "@memorang/types";

export type Slot =
	| "stimulus"
	| "item_image"
	| "item_audio"
	| "question_instruction"
	| "stem"
	| "choices"
	| "drag_drop"
	| "dropdown_blanks"
	| "matching_pair"
	| "hint"
	| "feedback";

export type LayoutConfig = {
	left: Slot[];
	right: Slot[];
	stacked: Slot[];
};

export type ArtifactLayoutConfig = {
	left: Slot[];
	right?: Slot[];
	stacked?: Slot[];
};

const MULTI_SELECT_SLOTS: Slot[] = [
	"stem",
	"question_instruction",
	"item_audio",
	"item_image",
	"choices",
	"hint",
	"feedback",
];

const SINGLE_SELECT_SLOTS: Slot[] = [
	"stem",
	"question_instruction",
	"item_audio",
	"item_image",
	"choices",
	"hint",
	"feedback",
];

const BLANK_DROPDOWN_SLOTS: Slot[] = [
	"question_instruction",
	"item_audio",
	"item_image",
	"dropdown_blanks",
	"feedback",
];

const DRAG_DROP_SLOTS: Slot[] = [
	"question_instruction",
	"item_audio",
	"item_image",
	"drag_drop",
	"feedback",
];

const MATCHING_PAIR_SLOTS: Slot[] = [
	"question_instruction",
	"matching_pair",
	"feedback",
];

const PASSAGE_LEFT: Slot[] = ["stimulus"];

export const ARTIFACT_LAYOUT = {
	PHOTOGRAPH: {
		left: PASSAGE_LEFT,
		right: ["stem", "question_instruction", "choices", "hint", "feedback"],
		stacked: [
			"stimulus",
			"stem",
			"question_instruction",
			"choices",
			"hint",
			"feedback",
		],
	},
	QUESTION_RESPONSE: {
		left: PASSAGE_LEFT,
	},
	CONVERSATION: {
		left: PASSAGE_LEFT,
	},
	TALKS: {
		left: PASSAGE_LEFT,
	},
	INCOMPLETE_SENTENCES: {
		left: PASSAGE_LEFT,
	},
	SINGLE_PASSAGE: {
		left: PASSAGE_LEFT,
	},
	MULTIPLE_PASSAGE: {
		left: PASSAGE_LEFT,
	},
	TEXT_COMPLETION: {
		left: PASSAGE_LEFT,
	},
} satisfies Record<ToeicArtifactType, ArtifactLayoutConfig>;

export const ITEM_TYPE_LAYOUT = {
	SINGLE_SELECT: {
		left: [],
		right: SINGLE_SELECT_SLOTS,
		stacked: SINGLE_SELECT_SLOTS,
	},
	MULTI_SELECT: {
		left: [],
		right: MULTI_SELECT_SLOTS,
		stacked: MULTI_SELECT_SLOTS,
	},
	BLANK_DROPDOWN: {
		left: [],
		right: BLANK_DROPDOWN_SLOTS,
		stacked: BLANK_DROPDOWN_SLOTS,
	},
	BLANK_DRAG_WORD: {
		left: [],
		right: DRAG_DROP_SLOTS,
		stacked: DRAG_DROP_SLOTS,
	},
	MATCHING_PAIR: {
		left: [],
		right: MATCHING_PAIR_SLOTS,
		stacked: MATCHING_PAIR_SLOTS,
	},
} satisfies Partial<Record<OriginalItemTypes, LayoutConfig>>;
